/** Format seconds as MM:SS (zero-padded) */
export function formatTime(seconds: number): string {
  const m = Math.floor(seconds / 60);
  const s = seconds % 60;
  return `${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
}

/** Safely format a date string, returning fallback on invalid input */
export function safeFormatDate(
  value: string | null | undefined,
  formatter: (d: Date) => string,
  fallback = '-',
): string {
  if (!value) return fallback;
  const d = new Date(value);
  return isNaN(d.getTime()) ? fallback : formatter(d);
}
